import React from 'react';
import styles from './Careers.module.css';

const CareerPage = () => {
  // Job data
  const jobs = [
    
    {
      id: '001',
      position: 'React Native Developer',
      skills: ['React Native', 'Typescript', 'REST APIs', 'CSS'],
      datePosted: '2025-04-15',
      applyBy: '2025-04-30',
      formLink: 'https://forms.gle/devopseng'
    },
    {
      id: '002',
      position: 'UI/UX Designer',
      skills: ['Figma', 'Adobe XD', 'Wireframing', 'Prototyping', 'User Research'],
      datePosted: '2025-05-20',
      applyBy: '2025-05-29',
      formLink: 'https://forms.gle/uiuxdesigner'
    },
    {
      id: '003',
      position: 'Frontend Developer - Intern',
      skills: ['React', 'JavaScript', 'HTML5', 'CSS3', 'TypeScript'],
      datePosted: '2025-06-03',
      applyBy: '2025-06-10',
      formLink: 'https://forms.gle/frontenddev'
    },
    {
      id: '004',
      position: 'Java Engineer -Intern',
      skills: ['Java8', 'SpringBoot', 'REST API', 'AWS', 'Git'],
      datePosted: '2025-06-10',
      applyBy: '2025-06-15',
      formLink: 'https://forms.gle/backendeng'
    },
    {
      id: '005',
      position: 'Data Analyst',
      skills: ['SQL', 'Python', 'Excel', 'Tableau', 'Statistics'],
      datePosted: '2025-07-05',
      applyBy: '2025-07-15',
      formLink: 'https://forms.gle/dataanalyst'
    }
  ];

  // Format date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // Check if job is active
  const isJobActive = (applyBy) => {
    const today = new Date().toISOString().split('T')[0];
    return applyBy >= today;
  };

  return (
    <div className={styles.careerPage}>
      <div className={styles.container}>
        {/* Header */}
        <header className={styles.header}>
          <h1>Career Opportunities</h1>
          <p>Join our team and help build the future with us</p>
        </header>

        {/* Jobs Table */}
        <div className={styles.tableContainer}>
          <table className={styles.jobsTable}>
            <thead>
              <tr>
                <th>Job ID</th>
                <th>Position</th>
                <th>Skills Required</th>
                <th>Date Posted</th>
                <th>Apply By</th>
                <th>Apply</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job) => (
                <tr key={job.id} className={isJobActive(job.applyBy) ? '' : styles.expiredRow}>
                  <td className={styles.jobId}>{job.id}</td>
                  <td className={styles.position}>{job.position}</td>
                  <td>
                    <div className={styles.skills}>
                      {job.skills.map((skill, index) => (
                        <span key={index} className={styles.skill}>{skill}</span>
                      ))}
                    </div>
                  </td>
                  <td>{formatDate(job.datePosted)}</td>
                  <td className={isJobActive(job.applyBy) ? '' : styles.expiredDate}>
                    {formatDate(job.applyBy)}
                    {!isJobActive(job.applyBy) && <span className={styles.expiredBadge}>Expired</span>}
                  </td>
                  <td>
                    <a 
                      href={job.formLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className={`${styles.applyBtn} ${!isJobActive(job.applyBy) ? styles.disabledBtn : ''}`}
                      onClick={(e) => !isJobActive(job.applyBy) && e.preventDefault()}
                    >
                      {isJobActive(job.applyBy) ? 'Apply Now' : 'Closed'}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Note */}
        <div className={styles.note}>
          <p>All applications must be submitted through the Google Form links provided.</p>
        </div>
      </div>
    </div>
  );
};

export default CareerPage;